var InteractionTargetType;
(function (InteractionTargetType) {
    InteractionTargetType["Input"] = "input";
    InteractionTargetType["Button"] = "button";
})(InteractionTargetType || (InteractionTargetType = {}));
export default InteractionTargetType;
